import DOMReady from '../../utils/DomReady';
import AjaxRequest from '../../utils/AjaxRequest.js';
 
let profilesToUnifyCheckboxes = []
let profilesToUnifyData = {};

DOMReady(() => { 
  const ev = document.querySelectorAll('.js-profile_status');
  ev && ev.forEach(item => {
    item.addEventListener('change', () => {
      const id = item.getAttribute('data-id');
      const profileStatus = item.value;
      const toUpdate = item.parentNode.parentNode.querySelector('.to-update');
      const route = `/professionals/admin/expert_profiles_management/${id}/set_profile_status`;
      AjaxRequest(route, { method: 'POST',  body:{id: id, profile_status: profileStatus}}, changeStatus(item, toUpdate));
      // Set profileStatus as -selected- on the correct option
      // Callback to change de AccountStatus
    })
  })

  const changeStatus = (item, toUpdate) => {
    if (item.value === 'verified') {
      toUpdate.innerHTML = 'freemium';
    } else if (item.value === 'unverified') {
      toUpdate.innerHTML = 'free';
    }
  }

  // PROFILE UNIFICATION
  const profileUnificationCheckboxes = document.querySelectorAll('.checkbox_unify_profile')
  const unifyProfileButton = document.getElementById('btn_unify_profiles')
  const sendUnifyProfileRequestBtn = document.getElementById('btn_send_unify_profiles')
  const selectMainProfileModal = document.getElementById('select_main_profile_modal')
  const addDisabledClass = element => element.setAttribute('disabled', 'true');
  const removeDisabledClass = element => element.removeAttribute('disabled');

  profileUnificationCheckboxes && profileUnificationCheckboxes.forEach(checkboxElement => {
    checkboxElement.addEventListener('change', ({ target: checkbox }) => {
      if (checkbox.checked) {
        profilesToUnifyCheckboxes.push(checkbox)
      } else {
        profilesToUnifyCheckboxes = profilesToUnifyCheckboxes.filter( element => element !== checkbox)
      }

      if (profilesToUnifyCheckboxes.length == 2) {
        profileUnificationCheckboxes && profileUnificationCheckboxes.forEach(addDisabledClass)
        profilesToUnifyCheckboxes.forEach(removeDisabledClass)
        removeDisabledClass(unifyProfileButton)
      } else if (profilesToUnifyCheckboxes.length < 2) {
        profileUnificationCheckboxes && profileUnificationCheckboxes.forEach(removeDisabledClass)
        addDisabledClass(unifyProfileButton)
      }

    })
  }) 

  unifyProfileButton && unifyProfileButton.addEventListener('click', () => {
    const profilesToUnifyDataFromCheckboxes = profilesToUnifyCheckboxes.map(({ dataset }) => JSON.parse(dataset.profile))
    renderSelectedProfilesData(profilesToUnifyDataFromCheckboxes)
  })

  sendUnifyProfileRequestBtn && sendUnifyProfileRequestBtn.addEventListener('click', () => {
    if (!profilesToUnifyData.main) {
      return window.alert('Select a main profile!')
    }

    if (profilesToUnifyData.replica.hasAccountLinked !== undefined) {
      return window.alert('Only the main account can have a Kenneth account linked')
    }

    addDisabledClass(sendUnifyProfileRequestBtn)

    const route = `/professionals/api/admin/unify_experts?original_expert=${profilesToUnifyData.main.slug}&expert_to_unify=${profilesToUnifyData.replica.slug}`
    AjaxRequest(
      route,
      { method: 'POST' },
      () => location.reload(),
      (err) => {
        console.error(err)
        removeDisabledClass(sendUnifyProfileRequestBtn)
      },
    )

  })

  const renderSelectedProfilesData = profilesData => {
    const profileCardTemplate = ({ id, index, name, status, accountType, email, date, hasAccountLinked, slug}) => (`
        <label
        class="modal__profile"
        for="profile-${index}"
        data-profile-id="${id}"
        data-profile-name="${name}"
        data-profile-slug="${slug}"
        ${hasAccountLinked && 'data-profile-has-account-linked'}
        >
          <div class="modal__profile-main-info">
            <div class="modal__profile-main-info__header">
              <p class="modal__profile-title">${name}</p>
              <span class="modal__profile-title__profile-status">${status}</span>
              <span class="modal__profile-title__profile-status">${accountType}</span>
            </div>
            <p class="modal__profile-text">${email || ''}</p>
            <p class="modal__profile-text">Date: ${date}</p>
            <p class="modal__profile-text">ID: ${id}</p>
          </div>
          <div class="modal__profile-side-info">
            <input id="profile-${index}" name="main-profile" type="radio">
          </div>
        </label>
     `)

    const profileCardElementTemplates = [1, 2].map((_, index) => {
      const profile = profilesData[index]
      return profileCardTemplate({
        id: profile.id,
        index,
        name: profile.name,
        status: profile.status,
        accountType: profile.account_type,
        email: profile.email,
        date: profile.created_at,
        hasAccountLinked: profile.has_account_linked,
        slug: profile.slug
      })
    }).join('')


    selectMainProfileModal && (selectMainProfileModal.querySelector('.modal__profiles-container__profiles').innerHTML = profileCardElementTemplates)
    addListenersToProfileCards(); 
    AFD.modals.open('#select_main_profile_modal')
  }

  const addListenersToProfileCards = _ => {
    selectMainProfileModal && selectMainProfileModal.querySelectorAll('.modal__profiles-container__profiles .modal__profile').forEach(profileCard => {
      profileCard.addEventListener('change', e => {
        e.stopPropagation()
        const replicaProfileCard = profileCard.nextElementSibling || profileCard.previousElementSibling

        profilesToUnifyData = {
          main: serializeProfileData(profileCard),
          replica: serializeProfileData(replicaProfileCard),
        }
      })
    })
  }

  const serializeProfileData = profileCard => ({
    name: profileCard.dataset.profileName,
    hasAccountLinked: profileCard.dataset.profileHasAccountLinked,
    slug: profileCard.dataset.profileSlug,
  })

  // UPDATE PROFILE NAME
  const openUpdateNameModalBtns = document.querySelectorAll('.btn__update_profile_name')
  const btnUpdateProfileName = document.querySelector('#btn_update_profile_name')

  let selectedProfileId = null

  openUpdateNameModalBtns?.forEach( btn => {
    btn.addEventListener('click', () => {
      selectedProfileId = btn.dataset.newsroomId
      AFD.modals.open('#update_profile_name_modal')
    })
  })

  btnUpdateProfileName?.addEventListener('click', () => {
    const nameInputValue = btnUpdateProfileName.previousElementSibling.value.trim()

     
    if (nameInputValue === '') {
      return alert(`The name can't be blank!`)
    }

    const confirmation = window.confirm(`Are you sure you want to set the name to: ${nameInputValue}`)

    if (confirmation) {
      const route = '/professionals/api/admin/update_expert_name'

      addDisabledClass(btnUpdateProfileName)

      AjaxRequest(
        route,
        {
          method: 'POST',
          body: { newsroom_id: selectedProfileId, new_name: nameInputValue},
        },
        ({ status }) => {
          if (status === 'success') {
            const selectedProfileNameElement = document.querySelector(`#profile-name-${selectedProfileId}`)
            selectedProfileNameElement.textContent = nameInputValue
            AFD.modals.closeNow('#update_profile_name_modal')
            btnUpdateProfileName.previousElementSibling.value = ''
            removeDisabledClass(btnUpdateProfileName)
          }
        },
        (err) => {
          console.error(err)
          removeDisabledClass(sendUnifyProfileRequestBtn)
        },
      )}
  })

})

